'use client'

import { SolidButton, Text } from '@macarongfactory/web-ui'

import { MycleLogoDefault } from '@/shared/assets/icons'

import { LOCK_AB_AF_SUB2 } from '../../_features/modoocar-lock-ab'
import { useLockAb } from '../../_features/modoocar-lock-ab/_hooks/useLockAb'
import {
  MODOOCAR_CODE,
  MODOOCAR_CTA_ONELINK_URL,
  MODOOCAR_EVENT,
  getAppCtaButtonText,
  useModoocarAppLink,
  useModoocarImpression,
  useModoocarTracking,
} from '../_features/modoocar'

interface ISideCtaProps {
  managingUserCount: number
}

const CTA_TITLE = '새 차 구매하시나요?'
const CTA_GRAPHIC_URL =
  'https://mycle.co.kr/resources/images/contents/img_modoocar_detail_cta_graphic.png'
const CTA_GRAPHIC_WIDTH_PX = 864
const CTA_GRAPHIC_HEIGHT_PX = 480
const CARD_BACKGROUND = 'linear-gradient(180deg, #00AFFF 17.3%, #BCEAFF 100%)'
const STICKY_TOP_OFFSET_PX = 81

const SideCta = ({ managingUserCount }: ISideCtaProps) => {
  const {
    data: { isLock },
  } = useLockAb()
  const buttonText = getAppCtaButtonText(isLock)
  const { itemClick, track } = useModoocarTracking()
  const openAppLink = useModoocarAppLink({
    fallbackUrl: MODOOCAR_CTA_ONELINK_URL,
    afSub2: LOCK_AB_AF_SUB2.SIDE_CTA,
  })
  const impressionRef = useModoocarImpression<HTMLDivElement>(() =>
    track(MODOOCAR_EVENT.SECTION_SHOW, {
      code: MODOOCAR_CODE.SIDE_CTA,
      type: 'button',
      label: buttonText,
    })
  )

  const handleClick = () =>
    openAppLink(() => itemClick(MODOOCAR_CODE.SIDE_CTA, 'button', buttonText))

  return (
    <div
      ref={impressionRef}
      className='sticky flex w-full flex-col gap-dimension-x6 overflow-hidden rounded-dimension-x5 px-dimension-x4 pb-dimension-x4 pt-dimension-x8 shadow-[0px_2px_4px_0px_rgba(0,0,0,0.06),0px_2px_12px_0px_rgba(0,0,0,0.08)]'
      style={{ top: STICKY_TOP_OFFSET_PX, background: CARD_BACKGROUND }}
    >
      <div className='flex flex-col items-center gap-dimension-x4'>
        <span className='text-foreground-static-white'>
          <MycleLogoDefault fill='currentColor' width='80' height='16' />
        </span>
        <div className='flex flex-col items-center gap-dimension-x2'>
          <Text
            variant='heading-3-bold'
            color='text-foreground-static-white'
            className='break-keep text-center'
          >
            {CTA_TITLE}
          </Text>
          <Text
            variant='title-1-semibold'
            color='text-foreground-static-white'
            className='break-keep text-center'
          >
            {`${managingUserCount.toLocaleString()}명 오너가 마이클로 관리중`}
          </Text>
        </div>
      </div>

      <div className='flex flex-col'>
        <div className='flex w-full items-center justify-center'>
          <img
            src={CTA_GRAPHIC_URL}
            alt=''
            aria-hidden
            width={CTA_GRAPHIC_WIDTH_PX}
            height={CTA_GRAPHIC_HEIGHT_PX}
            className='h-auto w-full'
          />
        </div>
        <SolidButton
          text={buttonText}
          variant='brand'
          size='large'
          fullWidth
          clickable={handleClick}
        />
      </div>
    </div>
  )
}

export default SideCta
